export default "__VITE_ASSET__CHKO0HYw__"